<template>
    <div>
        <Logo />
        <div class="row justify-content-center">
            <div class="col-11 col-xs-11 col-md-6">
                <h3>Your Recipients</h3>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-11 col-xs-11 col-md-6">
                <div v-for="recipient in recipients" v-bind:key="recipient.id">
                    <ion-card color="primary" style="background : var(--ion-color-dark-contrast); color : var(--ion-color-dark);">
                        <ion-card-header>
                            <!-- need a delete button -->
                            <ion-card-title>
                                {{recipient.name}}
                            </ion-card-title>
                            <ion-card-subtitle>
                                {{recipient.email}}
                            </ion-card-subtitle>
                        </ion-card-header>
                        <div class="delete-btn">
                            <ion-icon name="close" class="t-red" v-on:click="deleteRecipient(recipient)"></ion-icon>
                        </div>
                    </ion-card>
                </div>
                <div class="u-form u-mt1">
                    <h3>Add a new recipient</h3>
                    <ion-input placeholder="Name" :value="name" type="text" shape="round" v-on:ionInput="setName($event)" expand="full" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-input>
                    <ion-input placeholder="Email Address" :value="email" type="email" shape="round" v-on:ionInput="setEmail($event)" expand="full" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-input>
                    <ion-button shape="round" expand="full" v-on:click="addRecipient()" :disabled="!canSend">Add New Recipient</ion-button>
                </div>
            </div>
        </div>
        <return-home />
    </div>
</template>

<script>
import Logo from '@/components/Logo.vue'
import ReturnHome from '@/components/ReturnHome.vue'
import {auth} from '@/mixins/auth';
import {userdetails} from '@/mixins/userdetails';
import {alerts} from '@/mixins/alerts';

export default {
    name: 'recipients',
    mounted : function () {
        this.getRecipients();
    },
    components: {
        Logo, ReturnHome
    },
    mixins : [auth, userdetails, alerts],
    data : function () {
        return {
            recipients : [],
            name : '',
            email : ''
        }
    },
    computed : {
        canSend : function () {
            if (this.name == '' || this.email == '') {
                return false;
            }
            return true;
        }
    },
    methods : {
        getRecipients : function () {
            // get
            let self = this;
            this.axios.get(this.api + 'contacts')
                .then(response => {
                    self.recipients = response.data;
                })
                .catch(error => {
                    console.error('error getting recipients', error);
                })
        },
        addRecipient : function () {
            // get
            let self = this;
            this.axios.post(this.api + 'contacts', {name : this.name, email : this.email})
                .then(response => {
                    var msg = self.name + ' was added as a new recipient';
                    self.getRecipients();
                    self.showSuccess(msg, function () {
                        self.clearUser();
                    });
                })
                .catch(error => {
                    self.showError('We could not save the recipient.  Please check the data you provided and try again.');
                    console.error('error adding recipient', error);
                })
        },
        deleteRecipient : function (recipient) {
            let self = this;
            return this.$ionic.alertController
                .create({
                    cssClass : 'danger',
                    header: 'Are you sure?',
                    message: 'Please confirm that you want to remove ' + recipient.name + ' as a recipient. If you remove them they will not recieve messages, and will not be able to view messages.',
                    buttons: [{
                        text: 'Cancel',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                            console.debug('Cancelled');
                        }
                    }, {
                        text: 'Delete',
                        handler: () => {
                            self.axios.delete(self.api + 'contacts/' + recipient.id)
                                .then(response => {
                                    var msg = recipient.name + ' is no longer a recipient';
                                    self.getRecipients();
                                    self.showSuccess(msg, function () {
                                        self.clearUser();
                                    });
                                })
                                .catch(error => {
                                    console.error('error removing recipient', error);
                                })
                        },
                    },
                ],
                })
                .then(a => a.present());
            // confirm with warning
            // post
        },
        setName : function (event) {
            this.name = event.target.value;
        },
        setEmail : function (event) {
            this.email = event.target.value;
        },
        clearUser : function () {
            this.name = '';
            this.email = '';
        }
    }
}
</script>

<style>
ion-card-subtitle, ion-card-title {
    overflow-wrap: break-word;
    font-weight : normal;
}
</style>